import React, { useContext, useState } from "react";
import "./Top-Section-Pc.scss";

import { IoPersonOutline } from "react-icons/io5";

import { ReactComponent as NotificationBellIcon } from "../../../assets/icons/notification-bell.svg";

//data imports
import { useSelector } from "react-redux";

//import context
import { MyContext } from "../../../../tenantsDashContext";
import NotificationModal from "./notificationPopper";
import TenantTourControls from "../../TourFiles/TenantTourControls.jsx";

const TopSectionPc = ({ startTour, resetTour }) => {
  //context
  const { sharedValue, setSharedValue } = useContext(MyContext);
  const { activeItem, setActiveItem } = useContext(MyContext);
  //data from redux
  const user = useSelector((state) => state.landlordslice);

  //notifications
  const [notificationBadge, setNotificationBadge] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const toggleModal = () => {
    console.log("clicked");
    setIsModalOpen(!isModalOpen);
    console.log(isModalOpen);
  };

  return (
    <div className="top-section-pc">
      <div>
        {/* <div className="greeting">
        Hello, <span className="name">Timothy</span>
        </div>
        <div className="notification-text">
          <GoBell size={12} /> 
          <div style={{marginLeft:"2px"}}>
          no notifications at the moment
          </div>
        </div> */}
      </div>
      <div className="profile-and-notifications-container">
        {/* Tour Controls - positioned to the left of notification icon */}
        {sharedValue === "Overview" && (
          <TenantTourControls startTour={startTour} resetTour={resetTour} />
        )}
        <div
          className="notifications"
          onClick={() => {
            setIsModalOpen(true);
            setNotificationBadge(null);
          }}
        >
          <NotificationBellIcon size={25} />
          {/* <div className="badge">2</div> */}
        </div>
        {/* notifications modal */}
        <NotificationModal
          isModalOpen={isModalOpen}
          toggleModal={toggleModal}
          setNotificationBadge={setNotificationBadge}
        />
        {/* end of notifications modal */}
        <div className="profile-container">
          <div
            className={`notifications ${
              activeItem === "Profile" ? "active" : ""
            }`}
            onClick={() => {
              setActiveItem("Profile"); // Update the active item state when a nav item is clicked
              setSharedValue("Profile");
            }}
          >
            <IoPersonOutline size={25} />
          </div>
          <div className="name">{user?.user?.user?.user_name}</div>
        </div>
      </div>
    </div>
  );
};

export default TopSectionPc;
